import React, { useContext, useState } from 'react';
import SearchContext from '../context/SearchContext';
import { priceFormatter, thousands } from '../../helpers/Numbers';
import { 
	CheckboxFilter, 
	CheckboxFilterKeywords,
	FacetGroup, 
	MinMaxSlider, 
	RadioGroupPersonbilTransportbil, 
	RadioGroupState,
	MaxSlider,
	ToggleButton,
} from './filters'

const Filter = () => {
	const { handleParams, params, facets, carsInStock, toggleShowFilterInMobile } = useContext(SearchContext)
	const [filterPanelOpen, setFilterPanelOpen] = useState(false)

	console.log(facets);

	return (
		<>
			<div className='container'>
				<div className="filter-header">
					<h3 className="title">Bilfilter</h3>
					<a 
						onClick={()=>{
							toggleShowFilterInMobile()
						}}
						href="#stang-filter"
						className="close"
						title="Stäng">
							<CloseSvg />
					</a>
				</div>

				{(
					<FilterPanel
						open={filterPanelOpen}
						handleParams={handleParams}
						carsInStock={carsInStock}
						params={params}
						close={() => { setFilterPanelOpen(false)}}
						facets={facets}
						toggleShowFilterInMobile={toggleShowFilterInMobile}
					/>
				)}
			</div>
		</>
	)
}

/**
 * 	Filter panel component
 */
const FilterPanel = ({ facets, carsInStock, handleParams, params, toggleShowFilterInMobile }) => {
	const [showExpanded, setShowExpanded] = useState(false)

	return (
		<>
			<div className='fixed-wrapper'>
				<div className='filter-container' style={{position:'relative'}}>
					<div className="buttons">
						{/* New/Used */}
						<RadioGroupState handleParams={handleParams} params={params} />
						{/* Personbil/Transportbil */}
						<RadioGroupPersonbilTransportbil handleParams={handleParams} params={params} />
					</div>
					<div className="dropdowns">
                        <div className="dropdowns-item">
							{/* Chassi */}
							<FacetGroup
								handleParams={handleParams}
								params={params}
								facet={facets['chassis']}
								title={'Biltyp'}
								key={'chassis'}
								keyName={'chassis'}
							/>
                        </div>
                        <div className="dropdowns-item">
							{/* Manufacturer */}
                            <FacetGroup
								handleParams={handleParams}
								params={params}
								facet={facets.manufacturer}
								title={'Märke'}
								key={'manufacturer'}
								keyName={'manufacturer'} 
							/>
                        </div>
                        <div className="dropdowns-item">
							{/* Modell */}
                            <FacetGroup 
								handleParams={handleParams} 
								params={params} 
								facet={facets.modelSeries} 
								title={'Modell'} 
								key={'modelSeries'} 
								keyName={'modelSeries'} 
							/>
                        </div>
                        <div className="dropdowns-item">
							{/* GearBoxType */}
                            <FacetGroup 
								handleParams={handleParams} 
								params={params} 
								facet={facets.gearboxType} 
								title={'Växellåda'} 
								key={'gearboxType'} 
								keyName={'gearboxType'} 
							/>
                        </div>
                        <div className="dropdowns-item">
							{/* FuelType */}
                            <FacetGroup 
								handleParams={handleParams} 
								params={params} 
								facet={facets.fuelTypes} 
								title={'Drivmedel'} 
								key={'fuelTypes'} 
								keyName={'fuelTypes'} 
							/>
                        </div>
                        <div className="dropdowns-item">
							{/* Price */}
                            <MinMaxSlider 
								handleParams={handleParams} 
								params={params} 
								min={facets.priceMin.value} 
								max={facets.priceMax.value} 
								step="10000" 
								title='Pris' 
								formatter={priceFormatter} 
								keyName='price' 
							/>
                        </div>
                        <div className="dropdowns-item w50 extra_margin">
							{/* MonnthlyCost */}
                            <MaxSlider 
								handleParams={handleParams} 
								params={params} 
								min={facets.monthlyCostMin.value} 
								max={facets.monthlyCostMax.value} 
								step="100" 
								title='Välj månadskostnad' 
								formatter={priceFormatter} 
								keyName='monthlyCostMax'
								description="Finansiering beräknas med 72 månaders avbetalning"
							/>
                        </div>
                        <div className="dropdowns-item w50 extra_margin">
							{/* DownPayment */}
                            <MaxSlider 
								handleParams={handleParams} 
								params={params} 
								min={facets.downPaymentMin.value} 
								max={facets.downPaymentMax.value} 
								step="1000" 
								title='Kontantinsats' 
								formatter={priceFormatter} 
								keyName='downPaymentMax' 
							/>
                        </div>
						<div className="deals-wrapper">
							{/* Deal - Outlet */}


{/* <CheckboxFilterKeywords 
	handleParams={handleParams} 
	params={params} 
	label="Volvo Selekt" 
	keyName="Volvo-Selekt" 
/>							 */}
							{/* <ToggleButton
									handleParams={handleParams}
									params={params}
									label="Outlet"
									sub="Maxa fyndet! Bilar med sänkt pris & lägre ränta."
									paramName="activeDeals"
									paramValue="outlet"
							/> */}
							{/* Deal - Superdeal */}
							<ToggleButton
									handleParams={handleParams}
									params={params}
									label="Superdeal"
									sub="Först till kvarn på bilar med ett riktigt bra pris."
									paramName="activeDeals"
									paramValue="superdeal"
							/>

							<ToggleButton
									handleParams={handleParams}
									params={params}
									label="Volvo Selekt"
									sub="Garanti som motsvarar nybilsgaranti."
									// keyName="Volvo-Selekt"
									paramName="keywords"
									paramValue="Volvo-Selekt"
							/>
							{/* Deal - Demo */}
							<ToggleButton
									handleParams={handleParams}
									params={params}
									label="Demobil"
									sub="Nybilskänsla, garanti & låga mil till begagnatpris."
									paramName="activeDeals"
									paramValue="demo"
							/>
						</div>
					</div>

					<div className={`expandable-filters ${showExpanded ? '':' hidden'}`}>
						{/* Color */}
						<FacetGroup 
							handleParams={handleParams} 
							params={params} 
							facet={facets['color']} 
							title={'Färg'} 
							key={'color'} 
							keyName={'color'} 
						/>
						{/* City */}
						<FacetGroup 
							handleParams={handleParams} 
							params={params} 
							facet={facets['city']} 
							title={'Anläggning'} 
							key={'city'} 
							keyName={'city'} 
						/>
						{/* ModelYear */}
						<MinMaxSlider 
							handleParams={handleParams} 
							params={params} 
							min={facets.modelYearMin.value} 
							max={facets.modelYearMax.value} 
							step="1" 
							title='Årsmodell' 
							keyName='modelYear' 
						/>
						{/* Mileage */}
						<MinMaxSlider 
							handleParams={handleParams} 
							params={params} 
							min={facets.mileageMin.value} 
							max={facets.mileageMax.value} 
							step="1000" 
							title='Miltal' 
							formatter={thousands} 
							unit=' mil' 
							keyName='mileage' 
						/>
						{/* Segment */}
						<FacetGroup 
							handleParams={handleParams} 
							params={params} 
							facet={facets['segment']} 
							title={'Segment'} 
							key={'segment'} 
							keyName={'segment'} 
						/>
						{/* EngineBaseType */}
						<FacetGroup 
							handleParams={handleParams} 
							params={params} 
							facet={facets['engineBaseType']} 
							title={'Motortyp'} 
							key={'engineBaseType'} 
							keyName={'engineBaseType'} 
						/>


						<div className="checkboxes">
							{/* 7-Sits */}
							<CheckboxFilterKeywords 
								handleParams={handleParams} 
								params={params} 
								label="7-sits" 
								keyName="7-sits" 
							/>
							{/* Fyrhjulsdrift */}
							<CheckboxFilterKeywords 
								handleParams={handleParams} 
								params={params} 
								label="Fyrhjulsdrift" 
								keyName="Fyrhjulsdrift" 
							/>
							{/* Dragkrok */}
							<CheckboxFilterKeywords 
								handleParams={handleParams} 
								params={params} 
								label="Dragkrok" 
								keyName="Dragkrok" 
							/>
							{/* Motorvärmare */}
							<CheckboxFilterKeywords 
								handleParams={handleParams} 
								params={params} 
								label="Motorvärmare" 
								keyName="Motorvärmare" 
							/>
							{/* PrivatLeasing */}
							<CheckboxFilter 
								handleParams={handleParams} 
								params={params} 
								paramKey="leasingPrice" 
								label="Privatleasing" 
							/>
							{/* BegTest */}
							<CheckboxFilter
									handleParams={handleParams}
									params={params}
									paramKey="hasBegTest"
									label="Begagnattest"
							/>
							{/* NedsattPris */}
							<CheckboxFilterKeywords 
								handleParams={handleParams} 
								params={params} 
								label="Nedsatt 
								pris" 
								keyName="Nedsatt-pris" 
							/>
							{/* Kampanj */}
							{/* <CheckboxFilter handleParams={handleParams} params={params} paramKey="hasCampaigns" label="Kampanj" /> */}
							{/* VolvoSelect */}
							{/* <CheckboxFilterKeywords 
								handleParams={handleParams} 
								params={params} 
								label="Volvo Selekt" 
								keyName="Volvo-Selekt" 
							/> */}
							{/* DemoBil */}
							{/*<CheckboxFilterKeywords
								handleParams={handleParams}
								params={params}
								label="Demobil"
								keyName="Demo"
							/>*/}
							{/* Avdragbar moms */}
							<CheckboxFilter
									handleParams={handleParams}
									params={params}
									label="Avdragbar moms"
									paramKey="deductibleVat"
							/>
						</div>
					</div>
					<div className="filter-toolbar">
						<a 
							href="#toggle-expandable-filters"
							className={`filter-toggle chevron-toggle ${showExpanded ? 'chevron-up':'chevron-down'}`}
							onClick={(e)=>{ e.preventDefault(); setShowExpanded(!showExpanded) }}>
							{showExpanded ? 'Färre filter':'Fler filter'}
						</a>
						<div className="mobile-fixed">
							<a 
								href="#aterstall-filter" 
								title="Återställ filter"
								className="filter-reset"
								onClick={(e)=>{
									e.preventDefault()
									const reset = new URLSearchParams('');
									handleParams(reset)
								}}
							>Återställ filter</a>

							<a 
								className={`btn-large ${showExpanded ? 'show-in-desktop':''}`} 
								href="#visa-resultat"
								onClick={(e)=>{ 
									e.preventDefault()
									setShowExpanded(!showExpanded) 
									toggleShowFilterInMobile(false)

								}}>
								Visa {carsInStock} bilar i lager
							</a>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

const CloseSvg = () => {
	const style = {
		width: '16px',
		height: '16px',
		verticalAlign: 'middle'
	}
	return (
		<svg width="21" height="21" viewBox="0 0 21 21" style={style} xmlns="http://www.w3.org/2000/svg">
			<g fill="#000" fillRule="evenodd">
				<path d="M2.592.044l18.364 18.364-2.548 2.548L.044 2.592z"/>
				<path d="M0 18.364L18.364 0l2.548 2.548L2.548 20.912z"/>
			</g>
		</svg>
	)
} 

export default Filter